import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { useGetNewestData } from '@/clients/utoniq-core'
import {
  ConsoleOrders,
  ConsoleOrdersQuery,
  ConsoleOrdersQueryVariables,
  FetchNewConsoleOrders,
  FetchNewConsoleOrdersQuery,
  FetchNewConsoleOrdersQueryVariables,
  OrderBy,
  UserCartTransactionOrderBoxFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { router } = useRouter<{ userId: string }>()
  const params = new URLSearchParams(window.location.search)
  const sort = params.get('sort') === OrderBy.Asc ? OrderBy.Asc : OrderBy.Desc
  const [orderBy, setOrderBy] = useState<OrderBy>(sort)

  const { isFirstLoadRef } = useGetNewestData<
    FetchNewConsoleOrdersQuery,
    FetchNewConsoleOrdersQueryVariables
  >({
    query: FetchNewConsoleOrders,
    variables: { orderBy: orderBy, userId: router.query.userId },
    fields: [
      {
        fragmentName: 'UserCartTransactionOrderBox',
        fieldName: 'artistUserCartTransactionOrders',
        fragment: UserCartTransactionOrderBoxFragmentDoc,
      },
    ],
  })

  const { data, loading, fetchMore, refetch } = useQuery<
    ConsoleOrdersQuery,
    ConsoleOrdersQueryVariables
  >(ConsoleOrders, {
    variables: { orderBy: orderBy, userId: router.query.userId },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    onCompleted() {
      isFirstLoadRef.current = false
    },
  })

  return {
    state: {
      orderTransactions: data?.artistUserCartTransactionOrders ?? null,
      loading,
      artistId: user?.uid ?? '',
      user: user,
      artist: data?.artist ?? null,
      hasNextPage: !!data?.artistUserCartTransactionOrders.pageInfo.hasNextPage,
      sort: orderBy,
    },
    actions: {
      async onRefetch(orderBy) {
        setOrderBy(orderBy)
        await refetch({ orderBy })
      },
      async onFetchMore() {
        await fetchMore({
          variables: {
            orderBy,
            pageInput: {
              cursor: data?.artistUserCartTransactionOrders?.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})
